__turbopack_context__.v({
  "container": "zzhT-W_container",
  "loading": "zzhT-W_loading" + " " + "zzhT-W_container",
  "shimmer": "zzhT-W_shimmer",
  "text-bar-sweep": "zzhT-W_text-bar-sweep",
});
